import React, { useState, useEffect } from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import blueLogo from '../../assets/img/logos/12wbtlogo.png'
import { Link } from 'react-router-dom'
import appleBadge from "../../assets/img/logos/apple-store-badge.png";
import googleBadge from "../../assets/img/logos/google-play-badge-changed.png";
import FB from "../../assets/img/logos/FB.png";
import Insta from "../../assets/img/logos/Insta.png";
import Tiktok from "../../assets/img/logos/TikTok.png";


const Footer = () => {
  const classes = useStyles();
  const [is775pxScreen, setIs775pxScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIs775pxScreen(window.innerWidth < 775);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
      <div className={classes.footerContainer}>
        <Grid container className={classes.grid} style={{ marginTop: '25px' }}>
          {is775pxScreen ? (
              <>
                <Grid item md={12} className={classes.gridItem}>
                  <div className={classes.footerLogo}><img src={blueLogo} alt='12WBT Logo' className={classes.logo} /></div>
                  <div className={classes.socialContainer}>
                    <span><a href='https://www.facebook.com/12wbt'><img src={FB} alt='FB Logo' className={classes.sociaLogo} /></a></span>
                    <span><a href='https://www.instagram.com/12wbt'><img src={Insta} alt='Insta Logo' className={classes.sociaLogo} /></a></span>
                    <span><a href='https://www.tiktok.com/@12wbt'><img src={Tiktok} alt='Tiktok Logo' className={classes.sociaLogo} /></a></span>
                  </div>
                </Grid>
                <Grid item md={12} className={classes.gridItem} style={{marginTop: '21px'}}>
                  <div className={classes.storeDiv}>
                    <a href={process.env.REACT_APP_GOOGLE_PLAY_STORE}>
                      <img className={classes.badge + ' ' + classes.playStoreImg} src={googleBadge} alt='Google store' />
                    </a>
                  </div>
                  <div className={classes.storeDivApp}>
                    <a href={process.env.REACT_APP_APPLE_STORE}>
                      <img className={classes.badge + ' ' + classes.appStoreImg} src={appleBadge} alt='Apple store' />
                    </a>
                  </div>
                </Grid>
                <Grid item md={12} className={classes.gridItem} style={{marginTop: '15px'}}>
                  <div className={classes.footerContent}>
                <span>
                  Consult your healthcare professional before beginning any diet or fitness regime.
                  <br />
                  Copyright © {new Date().getFullYear()} 12WBT Trading Pty. Ltd.
                </span>
                    <div className={classes.siteLinks}>
                      <a href='https://www.12wbt.com/blog'>12WBT Blog</a>|
                      <Link to='/pre-season/guides/get-to-know-support'>Support Crew</Link>|
                      <a href='https://www.12wbt.com/careers'>Careers</a>|
                      <a href={`${process.env.REACT_APP_GO_SITE}help/ask-a-question`}>Contact Us</a>|
                      <a href='https://www.12wbt.com/terms'>Terms</a>|<a href='https://www.12wbt.com/privacy'>Privacy</a>
                    </div>
                    <div style={{ marginTop: '7px' }}>
                      *Results may vary. Exercise and proper diet are necessary to achieve and maintain weight loss.
                    </div>
                  </div>
                </Grid>
              </>
          ) : (
              <>
                <Grid item sm={12} md={2} className={classes.gridItem}>
                  <div><img src={blueLogo} alt='12WBT Logo' className={classes.logo} /></div>
                  <div className={classes.socialContainer}>
                    <span><a href='https://www.facebook.com/12wbt'><img src={FB} alt='FB Logo' className={classes.sociaLogo} /></a></span>
                    <span><a href='https://www.instagram.com/12wbt'><img src={Insta} alt='Insta Logo' className={classes.sociaLogo} /></a></span>
                    <span><a href='https://www.tiktok.com/@12wbt'><img src={Tiktok} alt='Tiktok Logo' className={classes.sociaLogo} /></a></span>
                  </div>
                </Grid>
                <Grid item sm={12} md={8} className={classes.gridItem}>
                  <div className={classes.footerContent} style={{ width: '79%' }}>
                <span>
                  Consult your healthcare professional before beginning any diet or fitness regime.
                  <br />
                  Copyright © {new Date().getFullYear()} 12WBT Trading Pty. Ltd.
                </span>
                    <div className={classes.siteLinks}>
                      <a href='https://www.12wbt.com/blog'>12WBT Blog</a>|
                      <Link to='/pre-season/guides/get-to-know-support'>Support Crew</Link>|
                      <a href='https://www.12wbt.com/careers'>Careers</a>|
                      <a href={`${process.env.REACT_APP_GO_SITE}help/ask-a-question`}>Contact Us</a>|
                      <a href='https://www.12wbt.com/terms'>Terms</a>|<a href='https://www.12wbt.com/privacy'>Privacy</a>
                    </div>
                    <div style={{ marginTop: '7px' }}>
                      *Results may vary. Exercise and proper diet are necessary to achieve and maintain weight loss.
                    </div>
                  </div>
                </Grid>
                <Grid item sm={12} md={2} className={classes.gridItem}>
                  <div className={classes.storeDiv}>
                    <a href={process.env.REACT_APP_GOOGLE_PLAY_STORE}>
                      <img className={classes.badge} src={googleBadge} alt='Google store' style={{ width: '181px', height: '54px' }} />
                    </a>
                  </div>
                  <div className={classes.storeDiv}>
                    <a href={process.env.REACT_APP_APPLE_STORE}>
                      <img className={classes.badge} src={appleBadge} alt='Apple store' style={{ width: '182px', height: '61px' }} />
                    </a>
                  </div>
                </Grid>
              </>
          )}
        </Grid>
      </div>
  );
}

const useStyles = makeStyles((theme) => ({
  footerContent: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '75px'
  },
  grid: {
    margin: 'auto',
    width: '90%'
  },
  footerContainer: {
    bottom: 0,
    minHeight: '8rem',
    // width: '80%',
    margin: 'auto',
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    color: '#999',
    textAlign: 'left',
    backgroundColor: '#FFFFFF',
    marginTop: '35px',
    '& a': {
      color: '#999',
      margin: '0x 5px'
    },
    '& p': {
      marginBottom: 0
    },
    ...theme.CSS.center
  },
  logo: {
    width: '184px',
    height: '74px'
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    '& span': {
      marginRight: '30px'
    },
    ...theme.CSS.center
  },
  siteLinks: {
    marginTop: '7px',
    '& :first-child': {
      marginLeft: '0px'
    },
    '& a': {
      margin: '0px 14px',
      textDecoration: 'none'
    },
    position: 'relative',
    display: 'inline-block'
  },
  badge: {
    // height: '45%',
    // width: '55%',
    margin: '0 1rem'
  },
  sociaLogo: {
    // height: '21px'
  },
  socialContainer: {
    marginTop: '25px',
    width: '200px'
  },
  storeDiv: {
    marginLeft: '31px'
  },
  playStoreImg: {
    width: '181px',
    height: '54px'
  },
  appStoreImg: {
    width: '182px',
    height: '61px'
  },
  [theme.breakpoints.down(960)]: {
    storeDiv: {
      marginLeft: '37px'
    }
  },
  [theme.breakpoints.down(913)]: {
    grid: {
      width: '85%'
    }
  },
  [theme.breakpoints.down(855)]: {
    grid: {
      // width: '75%'
    }
  },
  [theme.breakpoints.down('lg')]: {
    logo: {
      // width: '8rem'
    }
  },
  [theme.breakpoints.down(775)]: {
    footerLogo: {
      // position: 'absolute',
      // marginTop: '-63px'
    },
    gridItem: {
      display: 'block',
      '& span': {
        marginRight: '15px'
      }
    },
    socialContainer: {
      marginLeft: '485px',
      marginTop: '-45px'
    },
    footerContent: {
      marginLeft: '0'
    },
    storeDiv: {
      marginLeft: '-17px'
    },
    storeDivApp: {
      marginLeft: '424px',
      marginTop: '-57px'
    }
  },
  [theme.breakpoints.down(716)]: {
    socialContainer: {
      // marginLeft: '288px'
    },
    storeDivApp: {
      // marginLeft: '220px'
    }
  },
  [theme.breakpoints.down(680)]: {
    socialContainer: {
      marginLeft: '440px'
    },
    storeDivApp: {
      marginLeft: '380px'
    },
    gridItem: {
      width: '100%'
    }
  },
  [theme.breakpoints.down(653)]: {
    socialContainer: {
      marginLeft: '400px'
    },
    storeDivApp: {
      marginLeft: '340px'
    }
  },
  [theme.breakpoints.down('sm')]: {
    footerContainer: {
      // width: '95%',
      fontSize: '.8rem'
    },
    siteLinks: {
      '& a': {
        margin: '0 5px'
      }
    },
    logo: {
      // width: '5rem'
    },
    badge: {
      // width: '27%'
    }
  },
  [theme.breakpoints.down('xs')]: {
    footerContainer: { padding: '1rem 0' },
    logo: {
      margin: '1rem auto',
      // width: '7rem'
    },
    siteLinks: {
      '& a': {
        margin: '0px 2px'
      }
    }
  },
  [theme.breakpoints.down(590)]: {
    socialContainer: {
      marginLeft: '320px'
    },
    storeDivApp: {
      marginLeft: '260px'
    }
  },
  [theme.breakpoints.down(576)]: {
    socialContainer: {
      marginTop: '-43px'
    }
  },
  [theme.breakpoints.down(500)]: {
    socialContainer: {
      marginLeft: '280px'
    },
    storeDivApp: {
      marginLeft: '220px'
    }
  },
  [theme.breakpoints.down(455)]: {
    socialContainer: {
      marginLeft: '240px'
    },
    storeDivApp: {
      marginLeft: '180px'
    }
  },
  [theme.breakpoints.down(413)]: {
    socialContainer: {
      marginLeft: '200px'
    },
    storeDivApp: {
      marginLeft: '165px'
    },
    playStoreImg: {
      width: '160px',
      height: '51px'
    },
    appStoreImg: {
      width: '157px',
      height: '54px'
    }
  },
  [theme.breakpoints.down(370)]: {
    socialContainer: {
      marginLeft: '187px'
    },
    storeDivApp: {
      marginLeft: '155px'
    }
  }
}))

export default Footer
